import _ from 'lodash';

let location = null;
if (typeof window !== 'undefined') {
  location = _.pick(window.location, ['search', 'pathname']);
}

export const setLocation = newLocation => {
  location = newLocation;
};

export const parseGetParam = (val, search) => {
  let result = '';
  let tmp = [];

  (search || location.search).substr(1).split('&').forEach(item => {
    tmp = item.split('=');
    if (tmp[0] === val) {
      result = decodeURIComponent(tmp[1]);
    }
  });

  if (!result) {
    const query = decodeURIComponent(location.pathname).split('?')[1];
    if (!query) {
      return '';
    }

    query.split('&').forEach(item => {
      tmp = item.split('=');
      if (tmp[0] === val) {
        result = decodeURIComponent(tmp[1]);
      }
    });
  }

  return result;
};



// WEBPACK FOOTER //
// ./app/services/parse-get-param.js